const getScrollFadeStyles = (theme, withTopShadow, withBottomShadow) => {
    const topShadow = `inset ${withTopShadow ? '0 15px 15px -15px' : '0 0 0 0'} ${theme.palette.dropShadow.main}`;
    const bottomShadow = `inset ${withBottomShadow ? '0 -15px 15px -15px' : '0 0 0 0'} ${theme.palette.dropShadow.main}`;
    let middleShadow = withBottomShadow ? bottomShadow : topShadow;
    if (withTopShadow && withBottomShadow) {
        middleShadow = `${middleShadow}, ${topShadow}`;
    }
    return {
        bottom: topShadow,
        top: bottomShadow,
        middle: middleShadow,
    };
};

export { getScrollFadeStyles as default };
//# sourceMappingURL=getScrollFadeStyles.js.map
